import { render, staticRenderFns } from "./unpaid.vue?vue&type=template&id=04d97b74&"
import script from "./unpaid.vue?vue&type=script&lang=js&"
export * from "./unpaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports